import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Host,
    OnDestroy,
    OnInit,
    Optional,
    Renderer2,
    SkipSelf,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import {ControlAccessor} from "../../models/ControlAccessor";
import {ControlContainer} from "../../interfaces/ControlContainer";

@Component({
    selector: 'az-slider',
    templateUrl: './slider.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AzoraSlider extends ControlAccessor implements OnInit, AfterViewInit, OnDestroy {
    
    constructor(
            private _viewContainerRef: ViewContainerRef,
            private _changeDetectorRef: ChangeDetectorRef,
            private _elementRef: ElementRef,
            private _renderer: Renderer2,
            @Optional() @Host() @SkipSelf()  parent: ControlContainer
    ) {
        super(_elementRef, _changeDetectorRef);
        this.parent = parent;
    }
    
    ngOnInit(): void {
        super.ngOnInit();
        
        if (!this.root) {
            
            this.control.setControlState({
                value: this.value,
                props: {
                    label: this.label,
                    type: this.type,
                    clearable: this.clearable
                },
                schema: this.schema
            });
        }
    }
    
    ngAfterViewInit(): void {
    
    }
    
    ngOnDestroy(): void {
    }
    
    
}
